import React from 'react';
import ProceduresContext from './ProceduresContext';
import Button from '@material-ui/core/Button';
import UpArrow from '@material-ui/icons/KeyboardArrowUp';
import DownArrow from '@material-ui/icons/KeyboardArrowDown';
import styled from 'styled-components';

const ButtonContainer = styled.div`
    position:relative; 
    left:-13px;
    margin-top: 3px;
`

const ProcedureHeaderSortButton = ({title,property,children}) => {

    const context = React.useContext(ProceduresContext);

    let endIcon = null;

    if(context.propertyToSortBy === property)
    {
        if(!context.sortReverse){
            endIcon = <DownArrow fontSize='small' color="primary"/>
        }else {
            endIcon = <UpArrow fontSize='small' color="primary"/>

        }
    }
    return <ButtonContainer >
            <Button style={{maxHeight:18, justifyContent:'left'}}
            color="primary" 
            onClick={()=>context.setPropertyToSortBy(property)}
            >
                {children}<span>{endIcon}</span>
            </Button>
            </ButtonContainer>
}


export default ProcedureHeaderSortButton;